<template>
  <Disclosure v-slot="{ open }" as="nav">
    <div class="relative">
      <div class="absolute inset-y-0 right-0 flex items-center lg:hidden z-40">
        <!-- Mobile menu button-->
        <DisclosureButton class="relative inline-flex items-center justify-center rounded-md  text-white">
          <span class="absolute -inset-0.5" />
          <span class="sr-only">Open main menu</span>
          <Bars3Icon v-if="!open" class="block h-7 w-7" aria-hidden="true" />
          <XMarkIcon v-else class="block h-7 w-7" aria-hidden="true" />
        </DisclosureButton>
      </div>
      <div class="relative flex gap-6 lg:gap-8 items-center">
        <router-link :to="{name:'Home'}">
          <img class="h-10 md:h-11 w-auto" src="../../../../img/logo-white.svg" alt="GroupRev Logo">
        </router-link>
        <home-search class="hidden md:block md:max-w-[360px]" />
        <div class="items-center justify-end gap-8 grow whitespace-nowrap text-white lg:flex hidden">
          <router-link :to="{ name: 'StaticForOrganizationsPage'}">
            About
          </router-link>
          <router-link :to="{ name: 'StaticHowItWorksPage'}">
            How it works
          </router-link>
          <router-link v-if="!user" :to="{ name: 'Login' }">
            Login
          </router-link>
          <tw-button v-if="user" class="btn-nav" variant="amber" :to="{ name: 'DashboardPage' }">
            Dashboard
          </tw-button>
          <tw-button v-if="!user" class="btn-nav" variant="amber" @click="$refs.organizationRegisterIntegratedModal.open()">
            Sign Up
          </tw-button>
        </div>
      </div>
    </div>
    <DisclosurePanel class="lg:hidden text-white bg-gray-900 -mx-4 md:-mx-8 mt-4 md:px-8 px-4 py-6">
      <div class="flex flex-col gap-4 ">
        <tw-button v-if="user" block variant="amber" :to="{ name: 'DashboardPage' }" class="mb-1">
          Dashboard
        </tw-button>
        <tw-button v-if="!user" block variant="amber" class="mb-1" @click="$refs.organizationRegisterIntegratedModal.open()">
          Sign Up
        </tw-button>
        <router-link v-if="!user" :to="{ name: 'Login' }">
          Login
        </router-link>
        <router-link :to="{ name: 'StaticForOrganizationsPage'}">
          About
        </router-link>
        <router-link :to="{ name: 'StaticHowItWorksPage'}">
          How it works
        </router-link>
      </div>
      <div class="border-b border-gray-600 my-5" />
      <div class="flex flex-col gap-3 ">
        <router-link :to="{name: 'ContactPage'}" class="text-sm">
          Contact
        </router-link>
        <tw-button variant="link" class="text-sm">
          Support Center
        </tw-button>
      </div>
    </DisclosurePanel>
    <organization-register-integrated-modal ref="organizationRegisterIntegratedModal" />
  </Disclosure>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel, } from '@headlessui/vue'
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline'
import router from '@/router/index.js'
import { defineProps, onMounted, ref } from 'vue'

import HomeSearch from '@/components/home/home-search.vue'
import TwButton from '@/components/generic/tw-button.vue'

import OrganizationRegisterIntegratedModal from '@/components/organizations/organization-register-integrated-modal.vue'

const organizationRegisterIntegratedModal = ref(null)
// mounted
onMounted( () => {
  console.log('mounted')
  if(router.currentRoute.value.query.integrated_signup === '1') {
    console.log('open integrated signup modal')
    setTimeout( () => {
      console.log('timeout open integrated signup modal',organizationRegisterIntegratedModal)
      organizationRegisterIntegratedModal.value.open()
    }, 500)
  }
})

const props = defineProps({
  items: {
    type: Array,
    default: () => []
  },
  itemsRight: {
    type: Array,
    default: () => []
  },
  user: {
    type: Object,
    default: null
  }
})


</script>
